import type { GameManual } from '../../types';
import { weatherMachineChapters, weatherMachineFirstGame } from './content';

/**
 * Rewrite 3.0 — prose-first Weather Machine base manual.
 * Local source has no expansions; addons stay empty (ONE EXPANSION = ONE CHAPTER N/A).
 * Printed icon catalogues remain blocked — status stays partial, never ready.
 */
export const weatherMachineManual: GameManual = {
  chapters: weatherMachineChapters,
  firstGameSteps: weatherMachineFirstGame,
  addons: [],
};

export * from './content';
export * from './faq';
export * from './glossary';
export * from './guided';
export * from './quickReference';
export * from './commonMistakes';
export * from './scoring';
export * from './components';
export * from './icons';
export * from './search';
export * from './validate';
